import React from "react";
import RolesCard from "@/components/Roles/RolesCard";
import HelpPopover from "@/components/Roles/HelpPopover";
import FetchWrapper from "@/components/UI/FetchWraper";

export default function Roles() {
  return (
    <FetchWrapper endpointPrefix="auth" endpointSuffix="admin/users/">
      {(data) => <RolesContent users={data} />}
    </FetchWrapper>
  );
}

function RolesContent({ users }: { users: any[] }) {
  return (
    <div className="w-full h-screen flex flex-col">
      <div className="shrink-0 px-4.5 pt-7.5">
        <div className="flex items-center font-bold text-[18px] mb-5 gap-2">
          <p>User Roles & Permissions</p>
          <HelpPopover />
        </div>
      </div>
      <div className="flex-1 overflow-y-auto px-4.5 hide-scrollbar">
        <div className="sticky top-0 text-[#2B4752] font-medium bg-[#eff1f2] z-10 grid grid-cols-[1fr_2fr_2.5fr_1fr_1fr_1fr] gap-4 mb-3">
          <p className="ml-4 flex items-center">Role</p>
          <p className="ml-3 flex items-center">Name</p>
          <p className="ml-2 flex items-center">Email</p>
          <p className="items-center">
            Account
            <br />
            created
          </p>
          <p className="flex items-center">
            Account
            <br />
            deactivated
          </p>
          <p className="flex items-center">User origin</p>
        </div>
        <div>
          {users.map((user: any) => {
            return <RolesCard user={user} key={user.id} />;
          })}
        </div>
      </div>
    </div>
  );
}
